import React, { useEffect } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import SuccessIcon from '../../../../static/icons/success.svg';
import { Location } from 'react-router-dom';
import { LocationStateType } from '../GetStartedPageConnected';

type Props = {
    localization: any;
};
const RegistrationSuccess = ({ localization }: Props) => {
    const navigate = useNavigate();
    const location = useLocation() as Location<LocationStateType>;

    useEffect(() => {
        if (!location.state?.userHasRegistered) navigate('/getstarted');
    }, [Object.values(location?.state || {})]);

    return (
        <Container>
            <img src={SuccessIcon} width={120} alt={localization.edit} style={{ marginBottom: 20 }} />
            <Title>{localization.title}</Title>
            <SubTitle>{localization.sub_title}</SubTitle>
        </Container>
    );
};

const Container = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 10%;
    height: 100%;
`;

const Title = styled.div`
    font-weight: 700;
    font-size: 48px;
    line-height: 46px;
    max-width: 700px;
    text-align: center;
    letter-spacing: -0.75px;
    margin-bottom: 10px;
`;

const SubTitle = styled.div`
    font-size: 18px;
    line-height: 27px;
    margin-bottom: 32px;
    color: #454245;
    max-width: 700px;
    text-align: center;
`;

export default RegistrationSuccess;
